import { FormControlLabel, FormControl, FormLabel, FormHelperText, Typography, Radio, RadioGroup } from '@mui/material'
import { useTranslation } from 'react-i18next'

type DataType = {
    id: string
    name: string
}
type RadioGroupProps = {
    onChange: (value: string) => void
    dataSource: DataType[]
    name: string
    label: string
    selectedValue?: string
    disabled?: boolean
    required?: boolean
    helperText?: string
    alignment?: 'vertical' | 'horizontal'
    labelPlacement?: 'top' | 'bottom' | 'start' | 'end'
    overrideClass?: {}
}

const RadioGroupControl = (props: RadioGroupProps) => {
    const {
        dataSource,
        name,
        label,
        selectedValue,
        onChange,
        disabled = false,
        required = false,
        helperText,
        alignment = 'horizontal',
        labelPlacement = 'end',
        overrideClass,
    } = props
    const { t } = useTranslation()

    return (
        <div>
            <FormControl>
                {/* <FormLabel>
                    <div>
                        <label>{label}</label>
                        <label style={{ color: '#d32f2f' }}>{required && ' *'}</label>
                    </div>
                </FormLabel> */}
                <Typography>
                    {label} {!disabled && required && <label style={{ color: '#d32f2f' }}>{' *'}</label>}
                </Typography>
                <RadioGroup
                    row={alignment === 'horizontal' ? true : false}
                    aria-label={label}
                    name={name}
                    value={selectedValue}
                    onChange={(event: any) => {
                        onChange(event.target.value)
                    }}
                >
                    {dataSource.map((item: DataType) => (
                        <FormControlLabel
                            value={item.id}
                            control={<Radio color="primary" classes={overrideClass} />}
                            label={item.name}
                            labelPlacement={labelPlacement}
                            disabled={disabled}
                        />
                    ))}
                </RadioGroup>
                <FormHelperText>
                    <label style={{ color: '#d32f2f' }}>
                        {!disabled
                            ? required && !selectedValue
                                ? t('LABEL.SELECT_REQUIRED')
                                : helperText
                                ? helperText
                                : ''
                            : ''}
                    </label>
                </FormHelperText>
            </FormControl>
        </div>
    )
}

export default RadioGroupControl
